// extracted by mini-css-extract-plugin
export default {"chatBody":"body_chatBody__PSioQ","upperMessage":"body_upperMessage__sb5xg","loadMore":"body_loadMore__h0Yde","lastMessage":"body_lastMessage__gYxvs"};